const ChargingType_Icon = () => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="26" height="26" rx="13" fill="#F2F8F6" />
      <path
        d="M11.0852 9.32922C11.4557 9.51446 11.6058 9.96497 11.4206 10.3355L10.4633 12.25H12.2376C12.8007 12.25 13.167 12.8426 12.9152 13.3463L11.4206 16.3354C11.2353 16.7059 10.7848 16.8561 10.4144 16.6708C10.0439 16.4856 9.89369 16.0351 10.0789 15.6646L11.0362 13.75H9.26189C8.69876 13.75 8.33254 13.1574 8.58437 12.6538L10.0789 9.66464C10.2642 9.29415 10.7147 9.14398 11.0852 9.32922Z"
        fill="#79C8B0"
      />
      <path
        d="M11.0852 9.32922C11.4557 9.51446 11.6058 9.96497 11.4206 10.3355L10.4633 12.25H12.2376C12.8007 12.25 13.167 12.8426 12.9152 13.3463L11.4206 16.3354C11.2353 16.7059 10.7848 16.8561 10.4144 16.6708C10.0439 16.4856 9.89369 16.0351 10.0789 15.6646L11.0362 13.75H9.26189C8.69876 13.75 8.33254 13.1574 8.58437 12.6538L10.0789 9.66464C10.2642 9.29415 10.7147 9.14398 11.0852 9.32922Z"
        fill="url(#paint0_linear_1930_3122)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.25 7.75C6.25 6.92157 6.92157 6.25 7.75 6.25H13.75C14.5785 6.25 15.25 6.92157 15.25 7.75V13H16C16.8285 13 17.5 13.6715 17.5 14.5V16.375C17.5 16.5821 17.6679 16.75 17.875 16.75C18.0821 16.75 18.25 16.5821 18.25 16.375V11.8106L17.3125 10.8732L17.2803 10.9053C16.9874 11.1982 16.5126 11.1982 16.2197 10.9053C15.9268 10.6124 15.9268 10.1376 16.2197 9.84467L16.2519 9.8125L16.2197 9.78033C15.9268 9.48743 15.9268 9.01257 16.2197 8.71967C16.5126 8.42678 16.9874 8.42678 17.2803 8.71967L19.3106 10.75C19.592 11.0313 19.75 11.4128 19.75 11.8106V16.375C19.75 17.4105 18.9105 18.25 17.875 18.25C16.8395 18.25 16 17.4105 16 16.375V14.5H15.25V18.25C15.6642 18.25 16 18.5858 16 19C16 19.4142 15.6642 19.75 15.25 19.75H6.25C5.83579 19.75 5.5 19.4142 5.5 19C5.5 18.5858 5.83579 18.25 6.25 18.25V7.75ZM13.75 7.75V18.25H7.75V7.75H13.75Z"
        fill="#79C8B0"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.25 7.75C6.25 6.92157 6.92157 6.25 7.75 6.25H13.75C14.5785 6.25 15.25 6.92157 15.25 7.75V13H16C16.8285 13 17.5 13.6715 17.5 14.5V16.375C17.5 16.5821 17.6679 16.75 17.875 16.75C18.0821 16.75 18.25 16.5821 18.25 16.375V11.8106L17.3125 10.8732L17.2803 10.9053C16.9874 11.1982 16.5126 11.1982 16.2197 10.9053C15.9268 10.6124 15.9268 10.1376 16.2197 9.84467L16.2519 9.8125L16.2197 9.78033C15.9268 9.48743 15.9268 9.01257 16.2197 8.71967C16.5126 8.42678 16.9874 8.42678 17.2803 8.71967L19.3106 10.75C19.592 11.0313 19.75 11.4128 19.75 11.8106V16.375C19.75 17.4105 18.9105 18.25 17.875 18.25C16.8395 18.25 16 17.4105 16 16.375V14.5H15.25V18.25C15.6642 18.25 16 18.5858 16 19C16 19.4142 15.6642 19.75 15.25 19.75H6.25C5.83579 19.75 5.5 19.4142 5.5 19C5.5 18.5858 5.83579 18.25 6.25 18.25V7.75ZM13.75 7.75V18.25H7.75V7.75H13.75Z"
        fill="url(#paint1_linear_1930_3122)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1930_3122"
          x1="12.1537"
          y1="15.5001"
          x2="8.4085"
          y2="13.374"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#1FA37C" />
          <stop offset="1" stop-color="#1FA37C" stop-opacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1930_3122"
          x1="17.0781"
          y1="17.5"
          x2="9.22747"
          y2="9.64614"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#1FA37C" />
          <stop offset="1" stop-color="#1FA37C" stop-opacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default ChargingType_Icon;
